import React , {useState, useRef} from 'react';
import { useGlobalContext } from '../context';
import emailjs from '@emailjs/browser';
import { useTranslation } from 'react-i18next';
import {motion} from 'framer-motion';

function Contact() {

    const { t } = useTranslation();
    const {isContactOpen, closeContact, textEnter, buttonEnter, Leave, initialContact, final, animation1,} = useGlobalContext()
    
    const [fullName, setFullName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [networkError, setNetworkError] = useState(false);
    const [success, setSuccess] = useState(false);

    const form = useRef();

   const  sendEmail = async (e) => {
    e.preventDefault();

    if ( fullName === '' || phone === ''  || email === '' || message === '') {
        setError(true);
        return;
      }
    
      try {
        const result = await emailjs.sendForm('service_q8dl188', 'template_xqn4nfp', form.current, 'AaJ7yWroaGi5xzB_Q');
        console.log(form.current);
        console.log(result.text);
    
        // Check if the result is successful before updating the input fields
        if (result.status === 200) {
          // Clear input fields after successful submission
          setFullName('');
          setPhone('');
          setEmail('');
          setMessage('');
    
          // Reset error state
          setError(false);
          setNetworkError(false)
          setSuccess(true); // Set success to true
          e.target.reset();
        setTimeout(() => {
                    setSuccess(false); // Reset success after a certain time (e.g., 3 seconds)
                    closeContact();
        }, 2000);
        } else {
          // Handle other status codes if needed
          console.error(`Form submission failed with status ${result.status}`);
        }
      } catch (error) {
        console.log(error.text);
        // Handle errors if the promise is rejected
        setNetworkError(true);
      }
    };

  return (
    <section className={`${isContactOpen === true ? 'section contact':'sidebar__closed'}`}>
        <div className="contact__cover"></div>
        <div className="container contact__wrapper">
            <motion.div 
            animate={isContactOpen ? final : initialContact}
            transition={animation1}
            className="contact__container">
                <div className="contact__close_button_container">
                    <button onMouseEnter={buttonEnter}
                    onMouseLeave={Leave}  className="navbar__open_sidebar" onClick={() => closeContact()}>
                        <div className="navbar__open_sidebar_line sidebar__close sidebar__close_line1"/>
                        <div className="navbar__open_sidebar_line sidebar__close sidebar__close_line2"/>
                    </button>
                </div>
                <h2 className="contact__header">
                        {t('contact.title')}
                </h2>
                <p className="contact__paragraph">
                {t('contact.subtitle')}
                </p>
                
                <form ref={form} action="submit" onSubmit={sendEmail} className="contact__form">
                    <input
                        onMouseEnter={textEnter}
                        onMouseLeave={Leave} 
                        type='text'
                        placeholder={t('contact.placeholder.1')}
                        name="user_name"
                        onChange={(e) => setFullName(e.target.value)}
                    />
                    <input
                        onMouseEnter={textEnter}
                        onMouseLeave={Leave} 
                        type='email'
                        placeholder={t('contact.placeholder.2')}
                        name="user_email"
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        onMouseEnter={textEnter}
                        onMouseLeave={Leave} 
                        type='phone'
                        placeholder={t('contact.placeholder.3')}
                        name="user_phone"
                        onChange={(e) => setPhone(e.target.value)}
                    />
                    <textarea
                        onMouseEnter={textEnter}
                        onMouseLeave={Leave} 
                        type='text'
                        placeholder={t('contact.placeholder.4')}
                        className='contact__message'
                        name='message'
                        rows = {2}
                        onChange={(e) => setMessage(e.target.value)}
                    />
                    <button onMouseEnter={buttonEnter}
                        onMouseLeave={Leave}
                        className='contact__button'
                        type='submit'
                        value="Send">
                        {t('contact.submit')}
                    </button>
                    <div className="contact__error">
                        {error && <p>{t('contact.errormessage.emptyfield')}</p>}
                    </div>
                    <div className="contact__error">
                        {networkError && <p>{t('contact.errormessage.failed')}</p>}
                    </div>
                    <div className="contact__success">
                        {success && <p>Message sent successfully!</p>}
                    </div>
                </form>
            </motion.div>
        </div>
    </section>
  )
}

export default Contact